import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Flex } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import Header from '@app/components/Header';
import RootLoadingSpinnerComponent from '@app/components/Loading/RootLoadingSpinnerComponent';
import { TextFieldFontLoader } from '@app/components/TextField';
import PDFDraftPreviewBusinessPage from '@app/containers/PDFDraftPreviewBusinessPage';
import { usePDF } from '@app/hooks/usePDF';
import PDFDocumentContentLayout from '@app/libs/reactPdfJs/components/PDFDocumentContentLayout';
import PDFDocumentPageLayout from '@app/libs/reactPdfJs/components/PDFDocumentPageLayout';
import PDFContainer from '@app/libs/reactPdfJs/containers/PDFContainer';
import { zoomIn, zoomOut } from '@app/libs/reactPdfJs/store/actions';

export default function DraftPreviewPage() {
  const dispatch = useDispatch();

  const { pdf } = usePDF();

  function handleZoomIn() {
    dispatch(zoomIn());
  }

  function handleZoomOut() {
    dispatch(zoomOut());
  }

  return (
    <>
      {pdf ? (
        <div className="Background Background--dark-gray">
          <TextFieldFontLoader />
          <PDFDocumentPageLayout>
            <Header>
              <Flex flex="1" justifyContent="flex-end" px={2} py={5}>
                <Button
                  backgroundColor="inherit"
                  sx={{
                    border: 'none',
                    height: '100%',
                    '&:hover': { backgroundColor: 'inherit', color: 'white' },
                  }}
                  width="10px"
                  onClick={handleZoomIn}
                >
                  <FontAwesomeIcon className="EditorHeader__tool-btn-icon" icon={faCirclePlus} />
                </Button>
                <Button
                  backgroundColor="inherit"
                  sx={{
                    border: 'none',
                    height: '100%',
                    '&:hover': { backgroundColor: 'inherit', color: 'white' },
                  }}
                  width="10px"
                  onClick={handleZoomOut}
                >
                  <FontAwesomeIcon className="EditorHeader__tool-btn-icon" icon={faCircleMinus} />
                </Button>
              </Flex>
            </Header>
            <div className="EditorContentContainer">
              <PDFDocumentContentLayout>
                {pdf && (
                  <PDFContainer
                    PDFBusinessPage={PDFDraftPreviewBusinessPage}
                    src={pdf}
                    thumbnailContainerClassName="hidden"
                    useThumbnailViewer={false}
                  />
                )}
              </PDFDocumentContentLayout>
            </div>
          </PDFDocumentPageLayout>
        </div>
      ) : (
        <RootLoadingSpinnerComponent isLoading isOverlay />
      )}
    </>
  );
}
